import type { FC, MouseEvent } from "react";
import { useState } from "react";
import { Trans } from "react-i18next";
import { Alert, Spinner } from "react-bootstrap";

import { Link } from "react-router-dom";

import { generateImagePDF } from "utils/generateImagePDF";

interface Props {
  imagesUrl: string[];
}

export const IsGeometry: FC<Props> = ({ imagesUrl }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleButtonClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    if (isGenerating) return;

    setIsGenerating(true);
    generateImagePDF(imagesUrl)
      .catch(console.error)
      .finally(() => {
        setIsGenerating(false);
      });
  };

  return (
    <>
      <Alert variant={"danger"} className={"alert--icon-danger-vertical"}>
        <Trans
          i18nKey="warning.geometryExercise"
          ns="exercise"
          components={{
            lnk: (
              <Link
                to="#"
                onClick={handleButtonClick}
                aria-disabled={isGenerating}
                className={isGenerating ? "disabled" : undefined}
              />
            ),
            strong: <strong />,
          }}
        />
        {isGenerating ? (
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className={"ms-2"} />
        ) : null}
      </Alert>
    </>
  );
};
